// AP, Chicago Sun-Times, NPR, Politico, Reuters, The Atlantic, The Guardian, USA Today
export const DEFAULT_SOURCE_IDS = [
  '612d198036d90d23edb18e29',
  '6148e380beafe0f769a044af',
  '612d198036d90d23edb18e4f',
  '626be4b5ea038ce5c4708280',
  '5b9e8b15c0aa70001318447a',
  '5b9e8e59c0aa700013184483',
  '5b9af86fd5f4a90014f3d584',
  '5b9b0bafd5f4a90014f3d594',
];
